import ApiCommon from "api/ApiCommon"

export interface SubscriptionItemResp {
	name: string;
	code: string;
	description: string;
	timestart: string;
	timeend: string;
	price: number;
	fixtimestart?: boolean;
	fixtimeend?: boolean;
	extraGrzEnabled?: boolean;
	extraGrzMaxCount?: number;
	excludingCount?: number;
}

export interface SubscriptionResp {
	result: SubscriptionItemResp[];
}

export interface CalculateSubscriptionRequest {
	grz: string;
	phone: string;
	promoCode?: string;
	permissionKindCode: string;
	quantity: number;
	timestart: string;
}

export interface CalculateSubscriptionResult {
	ok: boolean;
	promoCodeInf?: {
		permissionKindCode: string;
		price: number | null;
		activationsAvailable: number;
		timestart: string | null;
		timeend: string | null;
		msg: string;
		code: number;
	};
	timestart: string;
	timeend: string;
	promo_msg: string;
	promoAppliedQuantity: number;
	amount: number;
	amountWithoutDiscount: number;
	discountAmount: number;
	grz: string;
	phone: string;
	promoCode: string;
	codeSubscription: string;
	quantity: number;
}

export interface CalculateSubscriptionResp {
	result: CalculateSubscriptionResult;
}

export type subscriptionPayType = {
	result: {
		refill: number,
		orderNumber: string,
		description: string,
		redirectURL: string,
		receipt_id?: string,
		receipt_url?: string
	}
}

export function getSubscription(zone: string | undefined, grz?: string, phone?: string): Promise<SubscriptionResp> {
	let url = '/subscription';
	const params = new URLSearchParams();
	
	if (grz) {
		params.append('grz', grz);
	}
	params.append('phone', phone ?? 'Не указан');
	
	if (params.toString()) {
		url += '?' + params.toString();
	}
	
	return ApiCommon.get(url, zone)
}

export function subscriptionPay(
	zone: string | undefined,
	grz: string,
	phone: string,
	paymentService: any,
	codeSubscription: string,
	amount: any,
	timestart: string,
	options?: {
		totalSum?: number;
		timeend?: string;
		quantity?: number;
		promoCode?: string;
		activationsPromoCode?: number;
		grzList?: string[];
	}
): Promise<subscriptionPayType> {
	let body = {
		"grz": grz,
		"phone": phone,
		"paymentService": paymentService,
		"codeSubscription": codeSubscription,
		"amount": amount,
		"timestart": timestart,
		...(options?.totalSum !== undefined ? { "totalSum": options.totalSum } : {}),
		...(options?.timeend ? { "timeend": options.timeend } : {}),
		...(options?.quantity !== undefined ? { "quantity": options.quantity } : {}),
		...(options?.promoCode ? { "promoCode": options.promoCode } : {}),
		...(options?.activationsPromoCode !== undefined ? { "activationsPromoCode": options.activationsPromoCode } : {}),
		...(options?.grzList?.length ? { "grzList": options.grzList } : {}),
	}
	return ApiCommon.post(`/paymentSubscription`, zone, body)
}

export function calculateSubscription(
	zone: string | undefined,
	body: CalculateSubscriptionRequest
): Promise<CalculateSubscriptionResp> {
	const request = {
		...body,
		...(body.promoCode ? { promoCode: body.promoCode } : {}),
	};
	if (!body.promoCode) {
		delete request.promoCode;
	}
	return ApiCommon.post('/calculateSubscription', zone, request);
}
